import { TProfessional } from 'types/appointment';

import { TeamMemberTile } from '../TeamMemberTile/TeamMemberTile';

interface CanvasTeamSectionProps {
  handleBook: (professional: TProfessional) => void;
  professionals: TProfessional[];
  staggerColumns?: boolean;
}

const CanvasTeamSection = ({
  handleBook,
  professionals,
  staggerColumns,
}: CanvasTeamSectionProps) => {
  return (
    <>
      {/* <Heading as="h1">TEAM</Heading> */}
      {professionals &&
        professionals.map((professional, idx) => (
          <TeamMemberTile
            key={professional.guid}
            professional={professional}
            handleBook={handleBook}
            staggerColumns={staggerColumns}
            idx={idx}
          />
        ))}
    </>
  );
};

export { CanvasTeamSection };
